import styled from '@emotion/styled';

export const ButtonContainer = styled.span`
	position: relative;
	display: flex;
	flex-direction: column;

	> button.button {
		padding: 1.15rem;
		border-radius: var(--small-border-radius);

		position: absolute;
		top: 1px;
		right: 1px;

		body[dir='rtl'] & {
			right: unset;
			left: 1px;
		}
	}
`;

export const UtilContainer = styled.div`
	position: absolute;
	padding: 1.3rem;
	right: 0rem;

	body[dir='rtl'] & {
		right: unset;
		left: 0rem;
	}
`;
